// Agreement endpoints on the current server require the settings permission.
export function permissionAllowed(admin, key) {
  if (!admin) return false;
  if (admin.role === "super") return true;
  const granted = Array.isArray(admin.permissions) ? admin.permissions : [];
  return granted.includes(key === "pages" ? "settings" : key);
}
